<template>
  <div class="container">
    <base-form/>
  </div>
</template>

<script>
import BaseForm from "./BaseForm.vue";
import {mapActions} from "vuex";

export default {
  name: "CreateForm",
  components: {BaseForm},
}
</script>


<style scoped>

</style>